/**
 * Rewrites eFlex/CMS placeholder CDN host in manifest URLs to the real Akamai VOD base.
 * Example: https://_VODCDN_/vod/... -> NEXT_PUBLIC_AKAMAI_CDN_URL (or fallback)
 */
export function rewriteVodCdnManifestUrl(rawManifestUrl: string): string {
  if (!rawManifestUrl) return rawManifestUrl

  const cdnBaseUrl =
    process.env.NEXT_PUBLIC_AKAMAI_CDN_URL || ''

  return rawManifestUrl.replace(/https?:\/\/_VODCDN_\/vod\//, cdnBaseUrl)
}
